import PhoneInput from 'react-phone-number-input';
import { CSSObject, styled, Theme } from '@mui/material/styles';
import { PhoneNumberInputProps } from '@shared/components/inputs/PhoneNumberInput/PhoneNumberInput.types';

export const StyledPhoneNumberInput = styled(
  (props: PhoneNumberInputProps) => (
    <PhoneInput
      {...props}
      onChange={props?.onChange ?? (() => {})}
      countries={['CA']} // ← only Canada in dropdown
      countryCallingCodeEditable={false} // ← prevents typing +44, +61, etc.
      addInternationalOption={false} // ← removes "International" from dropdown
      limitMaxLength
    />
  ),
  {
    shouldForwardProp: (prop) =>
      ![
        'height',
        'borderColor',
        'textAlign',
        'invalid',
        'fontSize',
        'borderRadius',
        'international',
        'color',
        'bgColor',
        'isDarkTheme',
      ].includes(prop as string),
  }
)<PhoneNumberInputProps>(
  ({
    theme,
    height,
    borderColor,
    textAlign,
    invalid,
    fontSize,
    borderRadius,
    color,
    bgColor,
    isDarkTheme,
  }: PhoneNumberInputProps & { theme: Theme }): CSSObject => ({
    display: 'flex',
    gap: '0 10px',
    flex: '1 1 auto',
    alignItems: 'center',
    width: '100%',
    height: height || '42px',
    padding: '0px 16px 0px 0px',
    border: invalid
      ? `1px solid ${theme.colors?.validationError} !important`
      : borderColor
        ? `1px solid ${borderColor}`
        : `1px solid ${theme.colors?.borderNoError}`,
    borderRadius: borderRadius || '10px',
    backgroundColor: bgColor || theme.colors?.white,
    fontFamily: 'Montserrat',
    fontSize: fontSize || '16px',
    fontWeight: 400,
    fontStyle: 'normal',
    color: color || theme.colors?.primary,
    textAlign: textAlign || ('left' as const),
    boxSizing: 'border-box' as const,

    '& .PhoneInputCountry': {
      pointerEvents: 'none' as const,

      '& .PhoneInputCountryIcon': {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        borderRadius: `${borderRadius || '10px'} 0 0 ${borderRadius || '10px'}`,
        backgroundColor: isDarkTheme ? `${theme.colors?.white}1A` : theme.colors?.phonePlusOneBg,
        width: '47px',
        height: `${height ? parseInt(height.replace('px', ''), 10) - 2 : 39}px`,

        '&.PhoneInputCountryIcon--border': {
          boxShadow: 'none',
        },

        '& .PhoneInputCountryIconImg': {
          width: '28px',
        },
      },

      '& .PhoneInputCountrySelect': {
        display: 'none',

        '& option': {
          fontFamily: 'Montserrat',
          fontSize: '16px',
        },
      },

      '& .PhoneInputCountrySelectArrow': {
        display: 'none',
      },
    },

    '& .PhoneInputInput': {
      appearance: 'none' as const,
      resize: 'none' as const,
      fontSize: 'inherit',
      fontWeight: 'inherit',
      fontStyle: 'inherit',
      color: 'inherit',
      width: '100%',
      height: '100%',
      border: 'none',
      outline: 'none',
      background: 'transparent',
      '&::placeholder': {
        color: theme.colors?.optional,
        fontSize: fontSize || '16px',
        fontFamily: 'Roboto',
        fontWeight: 400,
      },
      '&:-webkit-autofill': {
        WebkitBoxShadow: '0 0 0 100px #fff inset',
        WebkitTextFillColor: 'inherit',
      },
    },

    '&:focus-within': {
      border: invalid
        ? `1px solid ${theme.colors?.validationError} !important`
        : borderColor
          ? `1px solid ${borderColor}`
          : `1px solid ${theme.colors?.primary}`,
    },
  })
);
